import React, { useEffect } from 'react';

import SendIcon from '../assets/icons/send.svg';
import CaretDownIcon from '../assets/icons/caret-down.svg';

function Styleguide(): JSX.Element {
  useEffect(() => {
    const head = document.querySelector('head');

    if (head) {
      ['bootstrap.min.css', 'bootstrap-theme.min.css'].forEach((file) => {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = `https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/${file}`;
        link.crossOrigin = 'anonymous';
        head.appendChild(link);
      });
    }
  }, []);

  return (
    <div className="style-guide">
      <div className="container">
        <h1 className="page-header">ALEX Chat Style Guide</h1>
        <h2>Palette</h2>
        <div className="row">
          <div className="tile col-sm-3 black">
            <p>ALEX Black</p>
            <p>#333</p>
            <p>var(--outgoing-message-color)</p>
          </div>
          <div className="tile col-sm-3 white">
            <p>White</p>
            <p>#fff</p>
            <p>no variable</p>
          </div>
          <div className="tile col-sm-3 alex-blue">
            <p>ALEX Blue</p>
            <p>#066b92</p>
            <p>var(--alex-blue)</p>
          </div>
          <div className="tile col-sm-3 med-blue">
            <p>ALEX Medium Blue</p>
            <p>#00b8e0</p>
            <p>var(--alex-med-blue)</p>
          </div>
          <div className="tile col-sm-3 light-blue">
            <p>ALEX Light Blue</p>
            <p>#e1f9fb</p>
            <p>var(--alex-light-blue)</p>
          </div>
          <div className="tile col-sm-3 yellow">
            <p>ALEX Yellow</p>
            <p>#ffd831</p>
            <p>var(--alex-yellow)</p>
          </div>
          <div className="tile col-sm-3 green">
            <p>Green</p>
            <p>#a9e42d</p>
            <p>var(--green)</p>
          </div>
          <div className="tile col-sm-3 light-gray">
            <p>Light gray</p>
            <p>#f2f2f2</p>
            <p>var(--light-gray)</p>
          </div>
        </div>
        <h2>Typography</h2>
        <p>Museo Sans is the official font of ALEX Chat. No Foro here. We use these weights:</p>
        <div className="row">
          <div className="tile col-sm-4" style={{ fontWeight: 300, fontSize: '30px' }}>
            Museo Sans 300
          </div>
          <div className="tile col-sm-4" style={{ fontWeight: 500, fontSize: '30px' }}>
            Museo Sans 500
          </div>
          <div className="tile col-sm-4" style={{ fontWeight: 900, fontSize: '30px' }}>
            Museo Sans 900
          </div>
        </div>
        <h2>Outside of chat</h2>
        <p>Elements that exist outside of the chat experience</p>
        <div className="panel panel-default">
          <div className="panel-heading">
            <h3 className="panel-title">Chat open button</h3>
          </div>
          <div className="panel-body">
            <button className="Open-button" type="button" style={{ maxWidth: '375px' }}>
              Have more HR questions?
            </button>
          </div>
          <div className="panel-footer">
            <code>
              &lt;button className=&ldquo;Open-button&rdquo; type=&ldquo;button&rdquo;&gt;Have more
              HR questions?&lt;/button&gt;
            </code>
          </div>
        </div>

        <h2>Chat panel header</h2>
        <p>
          Some of these styles are inherited from being nested within a <code>header</code> tag. The
          background of this section is white.
        </p>
        <div className="panel panel-default">
          <div className="panel-heading">
            <h3 className="panel-title">Chat header title</h3>
          </div>
          <div className="panel-body header">
            <span>
              ALEX Chat
              <div className="circle" />
            </span>
          </div>
          <div className="panel-footer">
            <code>
              &lt;span&gt;ALEX Chat&lt;div
              className=&ldquo;circle&rdquo;&gt;&lt;/div&gt;&lt;/span&gt;
            </code>
          </div>
        </div>
        <div className="panel panel-default">
          <div className="panel-heading">
            <h3 className="panel-title">Chat minimize button</h3>
          </div>
          <div className="panel-body header">
            <button style={{ float: 'none' }} className="Minimize-button" type="button">
              <img src={CaretDownIcon} alt="collapse" />
            </button>
          </div>
          <div className="panel-footer">
            <code>
              &lt;button className=&ldquo;Minimize-button&rdquo;
              type=&ldquo;button&rdquo;&gt;&lt;img src=&#123;CaretDownIcon&#125;
              alt=&ldquo;collapse&rdquo; /&gt;&lt;/button&gt;
            </code>
          </div>
        </div>

        <h2>Chat panel body</h2>
        <p>
          All elements that appear within the body of the chat panel. The background of this section
          of the app is ALEX light blue
        </p>
        <div className="panel panel-default">
          <div className="panel-heading">
            <h3 className="panel-title">Incoming message</h3>
          </div>
          <div className="panel-body chat-body">
            <div className="Incoming-message">
              Got it. Your medical deductible for the year is $1400.
            </div>
          </div>
          <div className="panel-footer">
            <code>
              &lt;div className=&ldquo;Incoming-message&rdquo;&gt;Got it. Your medical deductible
              for the year is $1400.&lt;/div&gt;
            </code>
          </div>
        </div>

        <div className="panel panel-default">
          <div className="panel-heading">
            <h3 className="panel-title">Multiple Incoming messages</h3>
          </div>
          <div className="panel-body chat-body">
            <div className="Incoming-message">
              Got it. Your medical deductible for the year is $1400.
            </div>
            <div className="Incoming-message">
              To find out how much you&rsquo;ve paid towards that already this year, sign in to your
              Placeholder Medical account here...
            </div>
          </div>
          <div className="panel-footer">
            <code>
              &lt;div className=&ldquo;Incoming-message&rdquo;&gt;Got it. Your medical deductible
              for the year is $1400.&lt;/div&gt;
              <br />
              &lt;div className=&ldquo;Incoming-message&rdquo;&gt;To find out how much you&rsquo;ve
              paid towards that already this year, sign in to your Placeholder Medical account
              here...&lt;/div&gt;
            </code>
          </div>
        </div>

        <div className="panel panel-default">
          <div className="panel-heading">
            <h3 className="panel-title">Suggestion button</h3>
          </div>
          <div className="panel-body chat-body">
            <button type="button" className="Intro-button">
              What&rsquo;s my deductible?
            </button>
          </div>
          <div className="panel-footer">
            <code>
              &lt;button className=&ldquo;Intro-button&rdquo;&gt;What&rsquo;s my
              deductible?&lt;/button&gt;
            </code>
          </div>
        </div>

        <div className="panel panel-default">
          <div className="panel-heading">
            <h3 className="panel-title">Outgoing message</h3>
          </div>
          <div className="panel-body chat-body">
            <div className="Outgoing-message">
              What&rsquo;s up Chat bot? I got a question for you!
            </div>
          </div>
          <div className="panel-footer">
            <code>
              &lt;div className=&ldquo;Outgoing-message&rdquo;&gt;What&rsquo;s up Chat bot? I got a
              question for you!&lt;/div&gt;
            </code>
          </div>
        </div>

        <div className="panel panel-default">
          <div className="panel-heading">
            <h3 className="panel-title">Response button</h3>
          </div>
          <div className="panel-body chat-body">
            <button type="button" className="Response-button">
              Blue Edge HDHP with HSA
            </button>
          </div>
          <div className="panel-footer">
            <code>
              &lt;button className=&ldquo;Response-button&rdquo;&gt;Blue Edge HDHP with
              HSA&lt;/button&gt;
            </code>
          </div>
        </div>

        <h2>Chat panel input area</h2>
        <p>
          The footer area of the chat panel, with the text input and button. These are nested within
          a<code>form</code> element with the className <code>Input-area</code>. The background of
          this section is ALEX blue.
        </p>

        <div className="panel panel-default">
          <div className="panel-heading">
            <h3 className="panel-title">Text input area</h3>
          </div>
          <div className="panel-body input-area">
            <input
              style={{ width: '350px' }}
              className="Input-window"
              type="text"
              defaultValue=""
            />
          </div>
          <div className="panel-footer">
            <code>
              &lt;input className=&ldquo;Input-window&rdquo; type=&ldquo;text&rdquo;
              value=&ldquo;&rdquo;&gt;
            </code>
          </div>
        </div>

        <div className="panel panel-default">
          <div className="panel-heading">
            <h3 className="panel-title">Text input area (disabled)</h3>
          </div>
          <div className="panel-body input-area">
            <input
              style={{ width: '350px' }}
              className="Input-window"
              type="text"
              defaultValue=""
              disabled
            />
          </div>
          <div className="panel-footer">
            <code>
              &lt;input className=&ldquo;Input-window&rdquo; type=&ldquo;text&rdquo;
              value=&ldquo;&rdquo; disabled&gt;
            </code>
          </div>
        </div>

        <div className="panel panel-default">
          <div className="panel-heading">
            <h3 className="panel-title">Text input area submit button</h3>
          </div>
          <div className="panel-body input-area">
            <button type="submit">
              <img src={SendIcon} alt="send icon" className="send-icon" />
            </button>
          </div>
          <div className="panel-footer">
            <code>
              &lt;button type=&ldquo;submit&rdquo;&gt;&lt;img src=&#123;SendIcon&#125;
              alt=&ldquo;send icon&rdquo; className=&ldquo;send-icon&rdquo; /&gt;&lt;/button&gt;
            </code>
          </div>
        </div>

        <div className="panel panel-default">
          <div className="panel-heading">
            <h3 className="panel-title">Text input area submit button (disabled)</h3>
          </div>
          <div className="panel-body input-area">
            <button type="submit" disabled>
              <img src={SendIcon} alt="send icon" className="send-icon" />
            </button>
          </div>
          <div className="panel-footer">
            <code>
              &lt;button type=&ldquo;submit&rdquo; disabled&gt;&lt;img src=&#123;SendIcon&#125;
              alt=&ldquo;send icon&rdquo; className=&ldquo;send-icon&rdquo; /&gt;&lt;/button&gt;
            </code>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Styleguide;
